import { Config } from '../models';

export abstract class IGetConfig {
    abstract getConfiguration(): Config;
    abstract getStaticUrl(): string;
}
